"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUpcomingJobRange = exports.formatMonthDate = exports.formatTimestamp = exports.formatHourMinute = exports.formatShortDay = exports.formatDayMonthDate = exports.formatShortDate = exports.formatDateTimeNumeric = exports.formatDateNumeric = exports.formatDateTimeNoYear = exports.formatDateTime = exports.formatDate = exports.formatHourRange = exports.formatV2DateTime = exports.formatV1DateTime = exports.formatApiDate = exports.UNIX_TIMESTAMP_FORMAT = exports.DAY_SHORT_FORMAT = exports.MONTH_DATE_FORMAT_FR = exports.MONTH_DATE_FORMAT = exports.DAY_MONTH_DATE_FORMAT = exports.DATE_NUMERIC_FR_FORMAT = exports.DATE_NUMERIC_FORMAT = exports.DATE_SHORT_FORMAT = exports.TIME_FORMAT = exports.DATE_FORMAT_NO_YEAR_FR = exports.DATE_FORMAT_NO_YEAR = exports.DATE_FORMAT_FR = exports.DATE_FORMAT = exports.V2_DATE_TIME_FORMAT = exports.V1_DATE_TIME_FORMAT = exports.API_DATE_FORMAT = exports.EN_DASH = void 0;
// For date/time formatting, stick to Material Design guidelines
// unless a "Homee Rule" supersedes it.
//
// Material Guidelines:
// https://material.io/design/communication/data-formats.html#date-and-time
//
// Homee Guidelines:
// https://zeroheight.com/83195d329/p/060364-grammar--mechanics/t/08e4e2
/**
 * @external https://charbase.com/2013-unicode-en-dash
 */
exports.EN_DASH = '\u2013';
/**
 * @example "2020-12-07"
 */
exports.API_DATE_FORMAT = 'YYYY-MM-DD';
/**
 * @example "2020-12-07 08:59:59"
 */
exports.V1_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
/**
 * @example "2020-12-07T08:59:59.000Z"
 */
exports.V2_DATE_TIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
/**
 * @example "Dec 7, 2020"
 */
exports.DATE_FORMAT = 'll';
/**
 * @example "7 Dec 2021"
 */
exports.DATE_FORMAT_FR = 'D MMM YYYY';
/**
 * @example "Dec 7"
 */
exports.DATE_FORMAT_NO_YEAR = 'MMM D';
/**
 * @example "7 Dec"
 */
exports.DATE_FORMAT_NO_YEAR_FR = 'D MMM';
/**
 * Equivalent of h:mm A
 *
 * @example "8:59 AM"
 */
exports.TIME_FORMAT = 'LT';
/**
 * @example "Fri, Dec 7"
 */
exports.DATE_SHORT_FORMAT = 'ddd, MMM D';
/**
 * @example "12/07/2020"
 */
exports.DATE_NUMERIC_FORMAT = 'L';
/**
 * @example "2020-12-07"
 */
exports.DATE_NUMERIC_FR_FORMAT = 'YYYY-MM-DD';
/**
 * @example "Friday, December 07"
 */
exports.DAY_MONTH_DATE_FORMAT = 'dddd, MMMM D';
/**
 * @example "Dec 7"
 */
exports.MONTH_DATE_FORMAT = 'MMM D';
/**
 * @example "7 Dec"
 */
exports.MONTH_DATE_FORMAT_FR = 'D MMM';
/**
 * @example "Fri"
 */
exports.DAY_SHORT_FORMAT = 'ddd';
/**
 * @example "1360013296"
 */
exports.UNIX_TIMESTAMP_FORMAT = 'X';
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "2020-12-07"
 */
const formatApiDate = (moment) => {
    return moment.format(exports.API_DATE_FORMAT);
};
exports.formatApiDate = formatApiDate;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "2020-12-07 08:59:59"
 */
const formatV1DateTime = (moment) => {
    return moment.format(exports.V1_DATE_TIME_FORMAT);
};
exports.formatV1DateTime = formatV1DateTime;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "2020-12-07T08:59:59.000Z"
 */
const formatV2DateTime = (moment) => {
    return moment.format(exports.V2_DATE_TIME_FORMAT);
};
exports.formatV2DateTime = formatV2DateTime;
/**
 *
 * @param {Moment} start - The moment instance that holds the range's start time
 * @param {Moment} end - The moment instance that holds the range's end time
 * @return {string} Formatted date range, example: "8:30 AM-9:30 AM"
 */
const formatHourRange = (start, end) => {
    return `${start.format(exports.TIME_FORMAT)}${exports.EN_DASH}${end.format(exports.TIME_FORMAT)}`;
};
exports.formatHourRange = formatHourRange;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "Dec 7, 2020"
 */
const formatDate = (moment) => {
    if (moment.locale() === 'fr') {
        return moment.format(exports.DATE_FORMAT_FR);
    }
    return moment.format(exports.DATE_FORMAT);
};
exports.formatDate = formatDate;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "Dec 7, 2020, 8:59 PM"
 */
const formatDateTime = (moment) => {
    if (moment.locale() === 'fr') {
        return moment.format(`${exports.DATE_FORMAT_FR}, ${exports.TIME_FORMAT}`).replace('.', '');
    }
    return moment.format(`${exports.DATE_FORMAT}, ${exports.TIME_FORMAT}`);
};
exports.formatDateTime = formatDateTime;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "Dec 7, 8:59 PM"
 */
const formatDateTimeNoYear = (moment) => {
    if (moment.locale() === 'fr') {
        return moment.format(`${exports.DATE_FORMAT_NO_YEAR_FR}, ${exports.TIME_FORMAT}`).replace('.', '');
    }
    return moment.format(`${exports.DATE_FORMAT_NO_YEAR}, ${exports.TIME_FORMAT}`);
};
exports.formatDateTimeNoYear = formatDateTimeNoYear;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted numeric date, example: "12/7/2020"
 */
const formatDateNumeric = (moment) => {
    if (moment.locale() === 'fr') {
        return moment.format(exports.DATE_NUMERIC_FR_FORMAT);
    }
    return moment.format(exports.DATE_NUMERIC_FORMAT);
};
exports.formatDateNumeric = formatDateNumeric;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted numeric date time, example: "12/7/2020, 8:59 PM"
 */
const formatDateTimeNumeric = (moment) => {
    if (moment.locale() === 'fr') {
        return moment.format(`${exports.DATE_NUMERIC_FR_FORMAT}, ${exports.TIME_FORMAT}`);
    }
    return moment.format(`${exports.DATE_NUMERIC_FORMAT}, ${exports.TIME_FORMAT}`);
};
exports.formatDateTimeNumeric = formatDateTimeNumeric;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "Fri, Dec 7"
 */
const formatShortDate = (moment) => {
    return moment.format(exports.DATE_SHORT_FORMAT);
};
exports.formatShortDate = formatShortDate;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "Friday, December 07"
 */
const formatDayMonthDate = (moment) => {
    return moment.format(exports.DAY_MONTH_DATE_FORMAT);
};
exports.formatDayMonthDate = formatDayMonthDate;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "Fri"
 */
const formatShortDay = (moment) => {
    return moment.format(exports.DAY_SHORT_FORMAT);
};
exports.formatShortDay = formatShortDay;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date, example: "8:59 AM"
 */
const formatHourMinute = (moment) => {
    return moment.format(exports.TIME_FORMAT);
};
exports.formatHourMinute = formatHourMinute;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted Unix timestamp, example: "1360013296"
 */
const formatTimestamp = (moment) => {
    return moment.format(exports.UNIX_TIMESTAMP_FORMAT);
};
exports.formatTimestamp = formatTimestamp;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formattede date, example: "Dec 7"
 */
const formatMonthDate = (moment) => {
    if (moment.locale() === 'fr') {
        return moment.format(exports.MONTH_DATE_FORMAT_FR).replace('.', '');
    }
    return moment.format(exports.MONTH_DATE_FORMAT);
};
exports.formatMonthDate = formatMonthDate;
/**
 *
 * @param {Moment} moment - The moment instance to format
 * @return {string} Formatted date range, example: "Dec 7, between 8:30 AM-9:30 AM
 */
const formatUpcomingJobRange = (moment) => {
    const date = moment.format(exports.MONTH_DATE_FORMAT);
    const timeRangeMin = moment.format(exports.TIME_FORMAT);
    const timeRangeMax = moment
        .clone()
        .add(1, 'hour')
        .format(exports.TIME_FORMAT);
    return `${date}, ${timeRangeMin}${exports.EN_DASH}${timeRangeMax}`;
};
exports.formatUpcomingJobRange = formatUpcomingJobRange;
